module.exports = __webpack_public_path__ + "static/media/the-good-fight-mobile-1.edd8c600.png";